import { createContext, type ReactNode, useContext } from 'react';
import type { ApiClient } from './client.js';

const ApiContext = createContext<ApiClient | undefined>(undefined);

export function ApiProvider({ client, children }: { client: ApiClient; children: ReactNode }) {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const client = useContext(ApiContext);
  if (client === undefined) throw new Error('useApi() fuera de <ApiProvider>.');
  return client;
}
